import * as React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";

import { MySite } from "./MySiteForm";
import { Site } from "./Site";

export function SiteDashboard({ selected }) {

  const api = localStorage.getItem("api");
  const headers = useSelector((state) => state.header);

  const [sites, setSites] = useState([]);
  const [selectedSiteForEdit, setSelectedSiteForEdit] = useState({});
  const [selectedSiteForDelete, setSelectedSiteForDelete] = useState({});
  const [errors, setErrors] = useState(true);
  const [isLoading, setIsLoading] = useState(true);


  const fetchData = () => {
    setIsLoading(true);
    const requestBody = {
      path: "site",
      query: {},
      body: {},
      requestType: "GET",
    };

    axios
      .post(api + `/auth/piggyback`, requestBody, headers)
      .then((response) => {
        const transformedData = (response?.data || []).map((site) => ({
          id: site.id,
          tenantId: site.tenantId,
          name: site.name,
          location: site.location,
          customProperties: site.customProperties,
          createdAt: site.createdAt,
          updatedAt: site.updatedAt,
        }));

        setSites(transformedData);
        setErrors(false);
      })
      .catch(() => {
        setErrors(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>




    <div className="mainContainer emms-main-container">
          <header className="no-margin">
                    <figure className="emms-image-figure">
                      <img className="img emm-image" src={'https://storage.googleapis.com/content_ai_bucket_elhitech/content/sites_banner.png'} alt="Logo" />
                    </figure>
          </header>
      <div className="title-container">
        <div className="title">
    
        </div>
        <div>
          <MySite
            selectedOption={selected}
            editMode={!!selectedSiteForEdit?.id}
            siteData={selectedSiteForEdit}
            setSelectedSiteForEdit={setSelectedSiteForEdit}
            onSuccess={fetchData}
          />
        </div>
      </div>

      <div
        className="emms-main-container-left-align"
        style={{ marginLeft: "10%" }}
      >
        <Site
          selectedOption={selected}
          errors={errors}
          isLoading={isLoading}
          sites={sites}
          setSites={setSites}
          setSelectedSiteForEdit={setSelectedSiteForEdit}
          selectedSiteForDelete={selectedSiteForDelete}
          setSelectedSiteForDelete={setSelectedSiteForDelete}
        />
      </div>
    </div>
    </>
  );
}